import gql from 'graphql-tag'

export const EventDetailsFragment = gql`
  fragment EventDetailsFragment on Event {
    id
    title
    slug
    address
    city
    department {
      code
      name
    }
    paid
    date
    publisher
    publisher_logo
    description
    place
    participation_terms
    reservation_text
    event_link
    contact_link
    contact_email
    contact_phone
    type {
      id
      image_url
      title
    }
    # targets {
    #   id
    #   name
    # }
    accessibilityModes {
      id
      name
    }
  }
`
